import React, {useEffect, useState} from 'react'
import PageLayout from '../../../../components/PageLayout'
import {FormattedMessage, useIntl} from 'react-intl'
import { Divider, Stack, Typography } from '@mui/material'
import PaymentActions from '../components/PaymentActions'
import {profileSelector, userSelector} from '../../user/userSelectors'
import {getCarteTPActives, isCarteTPLoading} from '../../../webservices/carteTiersPayant/carteTiersPayantSelector'
import {downloadCarteTP, loadCarteTP} from '../../../webservices/carteTiersPayant/carteTiersPayantActions'
import {connect} from 'react-redux'
import Loader from '../../../../components/Loader'
import PaymentCardCell from '../components/PaymentCardCell'
import { getIndividuList, getIndividuListForManage, isAffiliationLoading } from '../../../webservices/affiliation/affiliationSelector'
import * as affiliationAction from '../../../webservices/affiliation/affiliationActions'
import Popup from '../../../../components/Popup'
import appConst from "../../../../constant/appConstants";
import {cardiboxActions, cardiboxSelectors} from "redux-cardibox";

type PaymentCardProps = {
	isCarteTpView?: boolean
}

const PaymentCardPage: React.FC<PaymentCardProps> = (
	{
		isCarteTpView,
		// @ts-ignore
		carteTP,
		// @ts-ignore
		loading,
		// @ts-ignore
		downloadCarteTP,
		// @ts-ignore
		loadCarteTP,
		// @ts-ignore
		isAffiliationLoading,
		// @ts-ignore
		allBeneficiaries,
		// @ts-ignore
		getAffiliation,
		// @ts-ignore
		getArticleByShortcut,
		// @ts-ignore
		carteTpArticle,
	}
) => {
	const intl = useIntl()
	const [isLoading, setIsLoading] = useState<boolean>(true)
	const [openNoCard, setOpenNoCard] = useState<boolean>(false)

	useEffect(() => {
		if (!carteTpArticle) {
			getArticleByShortcut(appConst.cardiboxApi, 'carte_tp_intro')
		}
	}, [getArticleByShortcut, carteTpArticle])

	useEffect(() => {
		loadCarteTP()
		getAffiliation()
		setIsLoading(false)
	}, [getAffiliation, loadCarteTP])

	if (loading || isAffiliationLoading || isLoading) {
		return <Loader />
	}

	return (
		<PageLayout title={intl.formatMessage({ id: 'paymentCard.title' })}>
			<Stack direction="column" spacing="24px">
				{carteTpArticle && <>
					<Typography variant="body2">
						<div dangerouslySetInnerHTML={{__html: carteTpArticle.fields.body}}/>
					</Typography>
					<Divider/>
				</>}
				{carteTP.map((carte: any, index: number) =>
					(
						<>
							{index !== 0 && <Divider />}
							<PaymentCardCell
								key={index}
								startingDate={carte?.assure?.debut || ''}
								endDate={carte?.assure?.fin || ''}
								beneficiaries={carte?.beneficiaires || []}
								assure={carte?.assure}
								allBeneficiaries={allBeneficiaries}
								openNoCard={() => setOpenNoCard(true)}
								downloadCarteTP={downloadCarteTP}
							/>
						</>
					))}
				{!isCarteTpView && <>
					<Divider />
					<PaymentActions />
				</>}
				<Popup
					maxWidth="600px"
					open={openNoCard}
					setOpen={setOpenNoCard}
					title={intl.formatMessage({ id: 'paymentCard.cardNotAvailable.title' })}
				>
					<Typography variant="body1">
						<FormattedMessage id="paymentCard.cardNotAvailable.body" />
					</Typography>
				</Popup>
			</Stack>
		</PageLayout>
	)
}

const mapStateToProps = (state: any) => ({
	carteTP: getCarteTPActives(state),
	loading: isCarteTPLoading(state),
	user: userSelector(state),
	profile: profileSelector(state),
	// @ts-ignore
	allBeneficiaries: getIndividuListForManage(state),
	isAffiliationLoading: isAffiliationLoading(state),
	carteTpArticle: cardiboxSelectors.articles.getByShortcut(state.cardibox)['carte_tp_intro']
})

const mappedActions = {
	loadCarteTP,
	downloadCarteTP,
	getAffiliation: affiliationAction.getAffiliation,
	getArticleByShortcut: cardiboxActions.articles.getByShortcut
}

export default connect(
	mapStateToProps,
	mappedActions
)(PaymentCardPage)
